import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA,
	getDeviceProductType
} from '../../dashboard/product-filter';

export const ERROR_TEMPLATE_WIFI = 'template-update-wifi';
export const ERROR_TEMPLATE_LOW_BATTERY = 'template-update-low-battery';
export const ERROR_TEMPLATE_PEDAL = 'template-activation-pedal';

export const getErrorMessageProductID = (log, device) => {
	const storedProducts = log ? [log.ProductID, log.Product] : [];
	for (let index = 0; index < storedProducts.length; index++) {
		const storedProduct = parseInt(storedProducts[index]);
		if (storedProduct === PRODUCT_TYPE_EVO || storedProduct === PRODUCT_TYPE_NOVA) {
			return storedProduct;
		}
	}

	const deviceProduct = getDeviceProductType(device);
	if (deviceProduct === PRODUCT_TYPE_EVO || deviceProduct === PRODUCT_TYPE_NOVA) {
		return deviceProduct;
	}

	const serialNumber = log && log.SerialNumber ? String(log.SerialNumber).trim().toUpperCase() : '';
	return serialNumber.indexOf('RJ') === 0 ? PRODUCT_TYPE_NOVA : null;
};

export const getErrorMessageProductLabel = productID => {
	if (parseInt(productID) === PRODUCT_TYPE_EVO) {
		return 'EVO';
	}

	if (parseInt(productID) === PRODUCT_TYPE_NOVA) {
		return 'Nova';
	}

	return 'Unknown';
};

export const getErrorMessageProductName = productID => {
	const label = getErrorMessageProductLabel(productID);
	return label === 'Unknown' ? 'Gemini laser' : 'Gemini ' + label;
};

export const getErrorMessageTemplateSubject = (template, productID) => {
	const productName = getErrorMessageProductName(productID);

	if (template === ERROR_TEMPLATE_WIFI) {
		return 'About your ' + productName + ' update due to Wi-Fi';
	}

	if (template === ERROR_TEMPLATE_LOW_BATTERY) {
		return 'About your ' + productName + ' update due to low battery';
	}

	if (template === ERROR_TEMPLATE_PEDAL) {
		return 'About your ' + productName + ' activation pedal pairing';
	}

	return '';
};
